module.exports = __webpack_public_path__ + "img/codehunter-locked.cd2ac7fe.svg";